import React from "react";
import { Layout } from "../components/Layout";
import { NewsFeed } from "../components/feed/NewsFeed";

let Feed = () => {
    return (
        <Layout thinHeader={true}>
            <NewsFeed />
        </Layout>
    );
};

export { Feed };



// WEBPACK FOOTER //
// ./src/pages/Feed.js